/*
  The states listed here do not allow ordering via Leafly. This list is used to hide ordering-related messaging. Modifications to this list must be confirmed with the Leafly Legal Team.
*/

const LeaflyOrderingNotAllowedStates = [
  "AB",
  "FL",
  "GA",
  "HI",
  "ID",
  "IN",
  "KS",
  "NC",
  "NE",
  "OH",
  "PA",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "WI",
  "WY",
];

export default LeaflyOrderingNotAllowedStates;
